import { Tooltip as VisxTooltip } from '@visx/tooltip';
import styled from 'styled-components';

const TooltipCard = styled(
    ({ chartHeight, chartWidth, offset, width, height, ...rest }) => (
        <VisxTooltip {...rest} />
    ),
)`
    position: absolute;
    background: ${({ theme }) => theme.gray_7};
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    font-family: ${({ theme }) => theme.style_primary};
    transition:
        top 0.1s,
        left 0.1s,
        transform 0.1s;
    box-shadow: 0px 4px 4.4px rgba(0, 0, 0, 0.11);
    width: ${({ width }) => `${width}px`};
    max-width: ${({ width }) => `${width}px`};
    min-height: ${({ height }) => `${height}px`};
    line-height: normal;
    transform: ${({
        width,
        height,
        left,
        top,
        chartWidth,
        chartHeight,
        offset,
    }) => {
        const x = left > chartWidth / 2 ? `-${width + offset}px` : `0`;
        const y = top > chartHeight / 2 ? `-${height + offset}px` : `0`;
        return `translate(${x}, ${y})`;
    }};
    & > * {
        margin: 0.8rem;
    }
`;

export default TooltipCard;
